import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "editor",
  "use": "editor-usage",
  "viewBox": "0 0 14 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 15\" id=\"editor\"><path d=\"M6.964 8.571C4.644 8.571 0 9.734 0 12.054V15h13.929v-2.946c0-2.32-5.674-3.483-6.965-3.483zm5.357 4.822H1.607v-1.34c0-.573 2.743-1.874 5.357-1.874 2.615 0 5.357 1.301 5.357 1.875v1.339zM6.964 7.5a3.75 3.75 0 000-7.5 3.754 3.754 0 00-3.75 3.75 3.754 3.754 0 003.75 3.75zm0-5.893a2.142 2.142 0 11.001 4.285 2.142 2.142 0 010-4.285z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol